import React from "react";

export const ForgotPasswordSentPage = () => (
    <div
        style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
            background: "#fafafa",
        }}
    >
        <div
            style={{
                background: "#fff",
                borderRadius: 8,
                boxShadow: "0 2px 8px 0 rgba(0,0,0,0.07)",
                padding: "48px 56px",
                minWidth: 320,
                textAlign: "center",
            }}
        >
            <div style={{ fontSize: 22, fontWeight: 600, color: "#18335B" }}>
                We’ve sent a password reset link to your{" "} 
                <span style={{ color: "#7A97C5", fontStyle: "italic" }}>email</span>.
                <br />
                Please check your inbox to continue.
            </div>
        </div>
    </div>
); 